class Config {
      public static get baseUrl() : string  {
           return process.env.REACT_APP_SOCKET_URL!;
        }

}

export default Config;